<vlaio-disclaimer *mediaQuery="mediaQuery" type="info" [verticalMargin]="verticalMargin">
	<p>{{ i18nKeys.Common.DesktopOnly | translate }}</p>
</vlaio-disclaimer>
